import { createBrowserRouter, RouterProvider } from "react-router";
import { builderRoutes } from "./builder/routes.js";
import { portalRoutes } from "./portal/routes.js";
import { Shell } from "./portal/Shell.js";
import { RouteError } from "./RouteError.js";

/**
 * Paths (DESIGN §16, §17.6):
 *   /                                  → this week's Plan (the sheet: Edit or View for the planner)
 *   /w/:monday                         → the Overview
 *   /w/:monday[/plan|/sessions|/day/:date|/session/:id|/track/:key|/athlete/:id|/lifts|/lift/:key]
 *   /builder, /builder/:monday         → old addresses, sent to the Plan
 *   /team                              → people, Plans the team (admin only)
 */
const router = createBrowserRouter([{ element: <Shell />, errorElement: <RouteError />, children: [{ errorElement: <RouteError />, children: [...portalRoutes, ...builderRoutes] }] }]);

export function App() {
  return <RouterProvider router={router} />;
}
